<template>
  <!-- 测试数据策略 请假申请 -->
  <div>
    <v-tabs
      v-model="tabs"
      grow
      active-class="tabactive"
      slider-size="50"
      :hide-slider="true"
    >
      <v-tab
        v-for="(item, index) in items"
        :key="index"
        class="text-capitalize"
      >
        {{ item.tab }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabs">
      <v-tab-item>
        <mrc_ess_table
          :headers="headers"
          v-if="$route.name == 'mrc_base_leaveApplication'"
          pageName="mrc_base_leaveApplication-add"
          :paginationOptions="paginationOptions"
          @turnPage="getList"
          :isLoading="loading"
          :items="desserts"
          :slotKey="['start_time', 'end_time', 'staff_uuid', 'company_uuid']"
        >
          <template v-slot:item.staff_uuid="{ item }">
            <mrc_ess_prompt
              :disabled="true"
              view
              v-model="item.staff_uuid"
              :select_arr="staffArr"
            ></mrc_ess_prompt>
          </template>
          <template v-slot:item.company_uuid="{ item }">
            <mrc_ess_prompt
              view
              :disabled="true"
              v-model="item.company_uuid"
              :select_arr="unitArr"
            ></mrc_ess_prompt>
          </template>
          <template v-slot:item.start_time="{ item }">
            {{ item.start_time | changeDate() }}
          </template>
          <template v-slot:item.end_time="{ item }">
            {{ item.end_time | changeDate() }}
          </template>
          <template v-slot:item.actions="{ item }">
            <menu-list :list="list" @handleClick="handleClick($event, item)">
              <template v-slot:showAction>
                <v-icon>mdi-dots-vertical</v-icon>
              </template>
            </menu-list>
          </template>
        </mrc_ess_table>
        <router-view v-else></router-view>
      </v-tab-item>
      <v-tab-item>
        <v-card>
          <v-card-text>
            当前uuid:{{ staffuuid }}
            <mrc_ess_chooseStaff v-model="staffuuid"> </mrc_ess_chooseStaff>
            <!-- <v-btn @success="submit"
                   style="margin-top:300px">提交数据赋值</v-btn> -->
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import {
  getChooseStaffTreeList,
  getStaffList,
  getPositionList,
  deleteGroup,
  addMyGroup,
  getDetailGroup,
  getSaveOrganization,
  addSaveOrganization,
  getGroupList,
} from "@/service/api/chooseStaff.js"
import { getTestLeaveApplicationList } from "@/service/api/data-access-strategy"
import { getBusinessList } from "@/service/api/prompt"
export default {
  components: {},
  props: {},
  data() {
    return {
      paginationOptions: {
        pagesize: this.$store.state.pageSize,
        cpage: this.$store.state.cpage,
        totalcount: 0, //总条数
        totalpage: 0, //总页数
      },
      unitArr: [],
      staffArr: [],
      loading: false,
      desserts: [],
      tabs: 0,
      staffuuid: "",
    }
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1)
  },
  async created() {},
  async mounted() {
    if (this.$route.name == "mrc_base_leaveApplication") {
      const res = await getBusinessList({
        prompt_name: "show_name",
      })
      if (res.code == 200) {
        this.staffArr = res.data
      } else {
        this.$Message({ text: "员工姓名参照未获取到，请刷新页面重新获取" })
      }
      const res1 = await getBusinessList({
        prompt_name: "unit",
      })
      if (res1.code == 200) {
        this.unitArr = res1.data
      } else {
        this.$Message({ text: "公司参照未获取到，请刷新页面重新获取" })
      }
      await this.getList()
    }
  },
  beforeDestroy() {},
  methods: {
    /**
     * @description: 获取列表
     * @param {type}
     * @return:
     * @author: lwq
     */
    async getList(obj) {
      if (obj) {
        this.paginationOptions = obj
      }
      this.loading = true
      const list = await getTestLeaveApplicationList({
        cpage: this.paginationOptions.cpage,
        pagesize: this.paginationOptions.pagesize,
      })
      if (list.code == 200) {
        this.desserts = list.data
        this.paginationOptions.totalcount = list.totalcount
        this.paginationOptions.totalpage = list.totalpage
      }
      this.loading = false
    },
    async submit(v) {
      const res = await addSaveOrganization({
        organizational_sub: v,
      })
      if (res.code == 200) {
        this.staffuuid = res.data.uuid
      }
    },
    /**
     * @description: 进入详情
     * @param {index} 点的第几个menu
     * @param {item} 点的整条数据
     * @return:
     * @author: lwq
     */
    handleClick({ item, index }, obj) {
      if (item.type == "del") {
        this.$myConfirm({ content: this.$t("message_Confirm_the_deletion") })
          .then(async () => {
            const del = await role_del({
              uuid: obj.uuid,
            })
            if (del.code == 200) {
              this.$Message({
                text: this.$t("message_The_deletion_was_successful"),
              })
              // this.desserts.length === 1  只有一条数据 删除就请求上一页的数据
              if (
                this.desserts.length === 1 &&
                this.paginationOptions.cpage > 1
              ) {
                this.paginationOptions.cpage--
              }
              await this.getList()
            }
          })
          .catch(() => {})
      }
    },
    /**
     * @description: 去添加页面
     * @param {type}
     * @return:
     * @author: lwq
     */
    handleAdd() {
      this.$router.push({
        name: "test-data-access-strategy-add",
      })
    },
  },
  computed: {
    list() {
      return [
        {
          name: this.$t("label_delete"),
          show: true,
          type: "del",
        },
      ]
    },
    items() {
      return [{ tab: this.$t("请假申请") }, { tab: this.$t("测试选人组件") }]
    },
    headers() {
      return [
        {
          text: this.$t("请假人"),
          align: "start",
          sortable: false,
          value: "staff_uuid",
        },
        {
          text: this.$t("所属公司"),
          align: "start",
          sortable: false,
          value: "company_uuid",
        },
        {
          text: this.$t("请假时间"),
          align: "start",
          sortable: false,
          value: "start_time",
        },
        {
          text: this.$t("结束时间"),
          align: "start",
          sortable: false,
          value: "end_time",
        },
        {
          text: this.$t("天数"),
          align: "start",
          sortable: false,
          value: "day",
        },
        {
          text: this.$t("请假原因"),
          align: "start",
          sortable: false,
          value: "cause",
        },
        // {
        //   text: ' ',
        //   align: 'end',
        //   sortable: false,
        //   value: 'actions',
        // },
      ]
    },
  },
  watch: {
    async $route(val) {
      if (val.name == "mrc_base_leaveApplication") {
        await this.getList()
        this.$store.commit("setTab", 0)
      }
    },
  },
}
</script>

<style scoped>
.role_name {
  display: flex;
  flex-direction: column;
  padding: 10px 0;
}
.name {
  font-size: 16px;
}
.desc {
  width: 160px;
  color: #afabab;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.org_level_name {
  overflow: hidden;
  padding: 10px;
  white-space: nowrap;
  max-width: 30vw;
}
</style>
